import { DateTime } from "luxon";
import React, { useContext } from "react";
import { Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { VehicleDataRow } from "./subcomponents";
import { vehicleType } from "../../../services/types.service";
import { FleetContext } from "../../../context";
import { withSpinner } from "../../../HOC";
import { withSnackbar } from "../../../HOC/withSnackbar";
import { CellReceptionDisplay } from "../../../components/Icons/CellReceptionDisplay";

const formatLastConnectTime = (datetimeStr) => {
  const dt = DateTime.fromSQL(datetimeStr);
  return `${dt.toLocaleString(DateTime.DATETIME_MED)} ${dt.toFormat("ZZZZ")}`;
};

export const VehicleCellularDetails = ({ vehicle }) => {
  const { t } = useTranslation();

  const { activeSIMConfig } = useContext(FleetContext);
  const hasActiveSession = activeSIMConfig?.lastsession?.active;
  const unknown = t("Vehicles.Detail.SIMDetails.Unknown");
  const usesImei = vehicle.type === "vehicle_api.segway";

  return (
    <Grid>
      <VehicleDataRow
        dataKey={t("Vehicles.Detail.CellSignal")}
        tooltip={t("Vehicles.Detail.SIMDetails.CellSignalHelpText")}
      >
        <CellReceptionDisplay percentage={hasActiveSession ? vehicle.cell_bars * 25 : 0} />
      </VehicleDataRow>

      <VehicleDataRow
        dataKey={t("Vehicles.Detail.SIMDetails.ICCID")}
        tooltip={t("Vehicles.Detail.SIMDetails.ICCIDHelpText")}
      >
        {activeSIMConfig?.links?.cellular?.length ? activeSIMConfig.links.cellular[0].sim : unknown}
      </VehicleDataRow>

      <VehicleDataRow
        dataKey={t("Vehicles.Detail.SIMDetails.Status")}
        tooltip={t("Vehicles.Detail.SIMDetails.StatusHelpText")}
      >
        {activeSIMConfig?.links?.cellular?.length
          ? activeSIMConfig?.links?.cellular[0].state
          : unknown}
      </VehicleDataRow>

      <VehicleDataRow
        dataKey={t("Vehicles.Detail.SIMDetails.IMEI")}
        tooltip={t("Vehicles.Detail.SIMDetails.IMEIHelpText")}
      >
        {activeSIMConfig && activeSIMConfig.imei}
      </VehicleDataRow>

      <VehicleDataRow
        dataKey={t("Vehicles.Detail.SIMDetails.IsConnected")}
        tooltip={t("Vehicles.Detail.SIMDetails.IsConnectedHelpText")}
      >
        {hasActiveSession ? "Yes" : "No"}
      </VehicleDataRow>

      {hasActiveSession ? (
        <VehicleDataRow
          dataKey={t("Vehicles.Detail.SIMDetails.CellNetwork")}
          tooltip={t("Vehicles.Detail.SIMDetails.CellNetworkHelpText")}
        >
          {activeSIMConfig?.lastsession?.network_name || unknown}
        </VehicleDataRow>
      ) : (
        <VehicleDataRow
          dataKey={t("Vehicles.Detail.SIMDetails.LastCellNetwork")}
          tooltip={t("Vehicles.Detail.SIMDetails.LastCellNetworkHelpText")}
        >
          {vehicle?.last_reported_network || unknown}
        </VehicleDataRow>
      )}

      <VehicleDataRow
        dataKey={t("Vehicles.Detail.SIMDetails.LastConnectTime")}
        tooltip={t("Vehicles.Detail.SIMDetails.LastConnectTimeHelpText")}
      >
        {activeSIMConfig?.lastsession?.session_begin
          ? formatLastConnectTime(`${activeSIMConfig.lastsession.session_begin} UTC`)
          : unknown}
      </VehicleDataRow>

      <VehicleDataRow
        dataKey={t("Vehicles.Detail.SIMDetails.NetworkGeneration")}
        tooltip={t("Vehicles.Detail.SIMDetails.NetworkGenerationHelpText")}
      >
        {activeSIMConfig?.lastsession?.radio_access_technology || ""}
      </VehicleDataRow>
    </Grid>
  );
};

VehicleCellularDetails.propTypes = {
  vehicle: vehicleType.isRequired,
};

export default withSpinner(withSnackbar(VehicleCellularDetails));
